export default {"src":"/_next/static/media/pickingVector.72937327.svg","height":15,"width":18,"blurWidth":0,"blurHeight":0};